import { takeLatest, put, call } from 'redux-saga/effects';
import {
  INIT_LOYALTY_DATA,
  CREATE_LOYALTY,
  EDIT_LOYALTY,
  RESET_LOYALTY,
  DEACTIVATE_LOYALTY,
  REACTIVATE_LOYALTY,
  LOAD_UNION_CATEGORIES_AND_ITEMS,
  LOAD_UNION_ITEM_VARIANTS,
} from 'actions/customers/loyalty/constants';

import * as apiProfile from 'api/profile';
import * as action from 'actions';
import * as actNotif from 'actions/notifications';
import * as loyaltyAction from 'actions/customers/loyalty';
import * as api from 'api/customers/loyalty';
import * as clevertapCustomersLoyalty from 'clevertap/customers/loyalty';
import { reset } from 'redux-form';
import _ from 'lodash';

export function* initLoyaltyDataFlow() {
  let payload;
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  yield put(reset('existingForm'));
  const response = yield call(api.getLoyalty);
  payload = { hasLoyalty: false };
  if (!_.isEmpty(response.data)) {
    [payload] = response.data;
    payload.hasLoyalty = true;
  }
  yield put(loyaltyAction.setLoyalty(payload));
  yield put(action.sendingRequest(false));
  yield put(action.hideProgressBar());
}

export function* createLoyaltyFlow(request) {
  const data = request.payload;
  let payload;
  try {
    yield put(action.sendingRequest(true));
    yield put(action.showProgressBar());
    yield call(api.createLoyalty, data);
    const response = yield call(api.getLoyalty);
    [payload] = response.data;
    payload.hasLoyalty = true;
    yield put(loyaltyAction.setLoyalty(payload));
    yield call(clevertapCustomersLoyalty.createLoyaltySuccess, data);
  } catch (error) {
    const displayErrorMessage =
      'Internal server error. Please try again later.';

    yield call(
      clevertapCustomersLoyalty.createLoyaltyFail,
      displayErrorMessage,
      error
    );
    yield put(actNotif.error(displayErrorMessage));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.hideProgressBar());
  }
}

export function* editLoyaltyFlow(request) {
  const data = request.payload;
  let payload;
  try {
    yield put(action.sendingRequest(true));
    yield put(action.showLoadingSpinner(true));
    yield call(api.editLoyalty, data.id, data);
    const response = yield call(api.getLoyalty);
    [payload] = response.data;
    yield put(loyaltyAction.setLoyalty(payload));
    yield put(actNotif.success('Loyalty program is saved successfully.'));
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.showLoadingSpinner(false));
  }
}

export function* resetLoyaltyFlow(request) {
  const data = request.payload;
  let payload;
  try {
    yield put(action.sendingRequest(true));
    yield put(action.showLoadingSpinner(true));
    yield call(api.resetLoyalty, data.id, data);
    const response = yield call(api.getLoyalty);
    [payload] = response.data;
    yield put(loyaltyAction.setLoyalty(payload));
    yield put(actNotif.success('Loyalty program is saved successfully.'));
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.showLoadingSpinner(false));
  }
}

export function* deactivateLoyaltyFlow(request) {
  const data = request.payload;
  let payload;
  try {
    yield put(action.sendingRequest(true));
    yield put(action.showLoadingSpinner(true));
    yield call(api.deactivateLoyalty, data.id);
    const response = yield call(api.getLoyalty);
    [payload] = response.data;
    yield put(loyaltyAction.setLoyalty(payload));
    yield put(actNotif.success('Loyalty program is saved successfully.'));
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.showLoadingSpinner(false));
  }
}

export function* reactivateLoyaltyFlow(request) {
  const data = request.payload;
  let payload;
  try {
    yield put(action.sendingRequest(true));
    yield put(action.showLoadingSpinner(true));
    yield call(api.reactivateLoyalty, data.id, data.reset);
    const response = yield call(api.getLoyalty);
    [payload] = response.data;
    yield put(loyaltyAction.setLoyalty(payload));
    yield put(actNotif.success('Loyalty program is saved successfully.'));
  } catch (error) {
    yield put(actNotif.error('Internal server error. Please try again later.'));
  } finally {
    yield put(action.sendingRequest(false));
    yield put(action.showLoadingSpinner(false));
  }
}

export function* loadUnionCategoriesAndItemsFlow() {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  const resProfile = yield call(apiProfile.getProfile);
  const response = yield call(
    api.getUnionCategoriesAndItems,
    resProfile.data.outlet_id[0],
    resProfile.data.user_outlets_id
  );
  yield put(loyaltyAction.setUnionItems(response.data.items));
  yield put(loyaltyAction.setUnionCategories(response.data.categories));
  yield put(action.sendingRequest(false));
  yield put(action.hideProgressBar());
}

export function* loadUnionItemVariantsFlow(request) {
  const { itemName } = request.payload;
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  const resProfile = yield call(apiProfile.getProfile);
  const responses = yield call(
    api.getUnionItemVariants,
    itemName,
    resProfile.data.outlet_id[0],
    resProfile.data.user_outlets_id
  );
  yield put(
    loyaltyAction.setUnionItemVariants(itemName, responses.data.variants)
  );
  yield put(action.sendingRequest(false));
  yield put(action.hideProgressBar());
}

export default function* customersLoyaltySaga() {
  yield takeLatest(INIT_LOYALTY_DATA, initLoyaltyDataFlow);
  yield takeLatest(CREATE_LOYALTY, createLoyaltyFlow);
  yield takeLatest(EDIT_LOYALTY, editLoyaltyFlow);
  yield takeLatest(RESET_LOYALTY, resetLoyaltyFlow);
  yield takeLatest(DEACTIVATE_LOYALTY, deactivateLoyaltyFlow);
  yield takeLatest(REACTIVATE_LOYALTY, reactivateLoyaltyFlow);
  yield takeLatest(
    LOAD_UNION_CATEGORIES_AND_ITEMS,
    loadUnionCategoriesAndItemsFlow
  );
  yield takeLatest(LOAD_UNION_ITEM_VARIANTS, loadUnionItemVariantsFlow);
}
